import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-h-border-panel__note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextLink = _resolveComponent("TextLink")!
  const _component_HBorderPanel = _resolveComponent("HBorderPanel")!
  const _component_HContainer = _resolveComponent("HContainer")!

  return (_ctx.courier)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HContainer, null, {
          content: _withCtx(() => [
            _createVNode(_component_HBorderPanel, { "spec-list-item": _ctx.courierDetail }, {
              heading: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("配送情報", -1)
              ])),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", null, [
                    _cache[1] || (_cache[1] = _createTextVNode(" 以下のURLからお客様のお荷物の配送状況がご確認いただけます。 ", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_TextLink, {
                      href: _ctx.courier.tracking_url,
                      "has-underline": true,
                      blank: true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.courier.tracking_url), 1)
                      ]),
                      _: 1
                    }, 8, ["href"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["spec-list-item"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}